import {get, post, put, del} from './apiMethods.js';
const WINHYDRO_URL = 'winhydro';

export const getAllAvailableStationIndexes = () => get(`${WINHYDRO_URL}/generic/station_indexes`);

export const getDistinctTypeNumbersByStationIndex = (station_index) =>  get(`${WINHYDRO_URL}/generic/type_numbers?station_index=${station_index}`);

export const getDistinctRatingTableListingsByStationIndex = (station_index) => get(`${WINHYDRO_URL}/generic/rating_table_listings?station_index=${station_index}`);

export const getRatingTableEntriesByRatingTypeNoAndStationIndex = ({station_index, rating_type_no}) => get(`${WINHYDRO_URL}/generic/rating_table?station_index=${station_index}&rating_type_no=${rating_type_no}`);

export const getAllRatingTableEntriesByStationIndex = (station_index) => get(`${WINHYDRO_URL}/generic/rating_table/all?station_index=${station_index}`);

export const postRatingTable = (data) => post(`${WINHYDRO_URL}/generic/rating_table_listing`, data);

export const updateRatingTable = (payload) => put(`${WINHYDRO_URL}/generic/rating_table`, payload);

export const updateRatingTableListing = (payload) => put(`${WINHYDRO_URL}/generic/rating_table_listing`, payload);

export const deleteRatingTableListing = (id) => del(`${WINHYDRO_URL}/generic/rating_table_listing/${id}`);



// WEBPACK FOOTER //
// ./src/actions/winhydro_api.js